import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import "../App.scss"; // Styles from App.scss
import { LiveAPIProvider } from "../contexts/LiveAPIContext";
import SidePanel from "../components/side-panel/SidePanel";
import { Altair } from "../components/altair/Altair";
import ControlTray from "../components/control-tray/ControlTray";
import cn from "classnames";
import { LiveClientOptions } from "../types";

interface MainAppLayoutProps {
  apiOptions: LiveClientOptions;
}

const MainAppLayout: React.FC<MainAppLayoutProps> = ({ apiOptions }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);

  return (
    <div className="App">
      <LiveAPIProvider options={apiOptions}>
        <div className="streaming-console">
            <Link to="/" className="back-to-home-arrow" title="Back to Home">
              <IoArrowBackOutline />
            </Link>
          <SidePanel />
          <main>
            <div className="main-app-area">
              <Altair />
              <video
                className={cn("stream", {
                  hidden: !videoRef.current || !videoStream,
                })}
                ref={videoRef}
                autoPlay
                playsInline
              />
            </div>
            <ControlTray
              videoRef={videoRef}
              supportsVideo={true}
              onVideoStreamChange={setVideoStream}
              enableEditingSettings={true}
            >
              {/* Children for ControlTray can be added here if needed */}
            </ControlTray>
          </main>
        </div>
      </LiveAPIProvider>
      {/* Feedback Button */}
      <a
        href="https://app.formbricks.com/s/cmbhb33f251jrtn0187cnj3nv"
        target="_blank"
        rel="noopener noreferrer"
        className="feedback-button"
      >
        feedback plz
      </a>
    </div>
  );
};

export default MainAppLayout;
